import React, { useState, useEffect } from "react";
import "./registration.css";

const RegistrationForm = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    vendorType: "",
    password: "",
    confirmPassword: "",
  });

  // ✅ Categories state
  const [categories, setCategories] = useState([]);
  const [vendorSubcategories, setVendorSubcategories] = useState([]);

  // ✅ Fetch vendor categories from backend
// ✅ Fetch vendor categories from backend
useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await fetch(`${API_URL}/categories`);
      const data = await res.json();

      // ✅ filter only Vendors category
      const vendorCategory = data.find(cat => cat.category === "Vendors");

      if (vendorCategory) {
        setVendorSubcategories(vendorCategory.subcategory); // ✅ now matches schema
      }

      setCategories(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  fetchCategories();
}, []);




  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/user/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        alert("✅ Registration successful!");
        console.log("Saved user:", data);
        setFormData({
          name: "",
          email: "",
          phone: "",
          role: "",
          vendorType: "",
          password: "",
          confirmPassword: "",
          uniqueName: "",
        });
      } else {
        alert(`❌ Error: ${data.message}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("❌ Something went wrong, try again!");
    }
  };

  return (
    <div className="registration-container">
      <div className="registration-card">
        <h2>Create an Account</h2>

        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div>
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          {/* Email */}
          <div>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          {/* Phone */}
          <div>
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Enter your phone number"
            />
          </div>

          {/* Role Selection */}
          <div>
            <label>Role</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="">-- Select Role --</option>
              <option value="user">User</option>
              <option value="venueProvider">Venue Provider</option>
              <option value="vendorProvider">Vendor Provider</option>
            </select>
          </div>

          {/* Vendor Type (only if Vendor Provider is selected) */}
          {formData.role === "vendorProvider" && (
            <div>
              <label>Vendor Type</label>
            <select
  name="vendorType"
  value={formData.vendorType}
  onChange={handleChange}
>
  <option value="">Select Vendor Type</option>
  {vendorSubcategories && vendorSubcategories.length > 0 ? (
    vendorSubcategories.map((sub) => (
      <option key={sub} value={sub}>{sub}</option>
    ))
  ) : (
    <option disabled>No vendor types available</option>
  )}
</select>

            </div>
          )}

          {/* Password */}
          <div>
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Re-enter your password"
            />
          </div>

          {/* Submit Button */}
          <button type="submit">Register</button>
        </form>

        <p>
          Already have an account? <a href="/">Login</a>
        </p>
      </div>
    </div>
  );
};

export default RegistrationForm;
